if (document.getElementById("wpforms-form-3568")) {
    const form = document.getElementById("wpforms-form-3568")
    form.insertAdjacentHTML('afterbegin', '<div class="close" onclick="closeModal()" >&times;</div>')
}

const closeModal = () => { 
    document.getElementById('wpforms-3568').classList.remove('active')
}

const openModal = (id, title, termin) => { 
    const form = document.getElementById(id)
    const veranstaltung = document.getElementById('wpforms-3568-field_1')
    let datum = document.getElementById('wpforms-3568-field_2')

    form.classList.add('active')
    veranstaltung.value = title
    datum.value = termin.replace('/', ".").replace('/', ".")
}